// extracted by mini-css-extract-plugin
export default {"hiddenIcon":"BlobActionsMenu-module__hiddenIcon__Jq8DpMr"};